<template>
  <v-col
    :cols="cols"
    :id="
      'screen-info-' +
        title
          .toLowerCase()
          .split(' ')
          .join('-')
    "
  >
    <div v-if="checkbox" class="mx-4">
      <span class="px-2" style="font-size: 12px;">{{ title }}</span>
      <v-checkbox
        dense
        :label="info ? `Yes` : `No`"
        :disabled="!editable"
        style="height:29px;"
        v-model="info"
        class="mt-1 pt-0 ml-2"
        @input="$emit('update:info', info)"
      />
    </div>
    <div v-else>
      <div v-if="editable && !readOnly" class="mx-4 mt-n4">
        <v-select
          v-if="select"
          dense
          filled
          hide-details
          :label="title"
          style="height:29px;"
          v-model="info"
          :items="items"
          class="my-5"
          @input="$emit('update:info', info)"
        />
        <v-text-field
          v-else
          dense
          hide-details
          filled
          :rules="phone ? [rules.phoneLength] : []"
          :label="title"
          v-model="info"
          style="height:29px;"
          class="my-5"
          @input="$emit('update:info', info)"
        />
      </div>
      <div v-else class="mx-4">
        <span class="px-2" style="font-size: 12px;">{{ title }}</span>
        <slot>
          <div
            class="d-flex align-center text-capitalize text-truncate px-2"
            style="height:29px; font-size: 12px;"
          >
            <h2 v-if="type === 'title'">
              {{ info }}
            </h2>
            <h3 v-else>
              {{ info && info.text ? info.text : info }}
            </h3>
          </div>
        </slot>
      </div>
    </div>
  </v-col>
</template>
<script>
import { MobileView } from '@/mixins';
import ScreenDetailData from '@/mixins/ScreenDetailData';

export default {
  data() {
    return {
      rules: {
        phoneLength: (v) => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v)
          || 'Please enter a valid 10 digit phone number',
      },
    };
  },
  props: {
    info: [String, Number, Boolean],
    title: String,
    type: String,
    select: Boolean,
    items: Array,
    phone: Boolean,
    cols: Number,
    checkbox: Boolean,
    readOnly: Boolean,
  },
  mixins: [MobileView, ScreenDetailData],
};
</script>
